// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"106":"5532c240","823":"87c68606"}[chunkId] + ".chunk.css";
};